import { TopbarData } from '@displate/styleguide';

import { TopBar } from 'generatedBfw/static';

export const mapTopBar = (topBar: TopBar): TopbarData => {
  return {
    textDesktop: topBar.contentDesktop,
    textMobile: topBar.contentMobile,
    backgroundColor: topBar.backgroundColor,
    fontColor: topBar.fontColor,
  };
};
